<section class="gtmpage-about">
    <header class="d-flex justify-content-center rounded-0 text-center fw-bold font-size-40">
        <h1 class="text-white">About PBS LearningMedia</h1>
    </header>

    <nav
        class="d-flex justify-content-center bg-navy-blue fw-bold font-size-16"
        *ngIf="isDesktop$ | async"
    >
        <app-link
            *ngFor="let route of aboutRoutes"
            [appRouterLink]="isAddonView ? null : route.routerLink"
            [href]="isAddonView ? route.routerLink : null"
            [attr.data-gtmlabel]="route.routerLink"
            [routerLinkActive]="'active'"
            [target]="'_blank'"
            class="d-flex justify-content-start text-white font-size-bold font-size-16 {{
                getGTMClass(route.name)
            }}"
        >
            {{ route.name }}
        </app-link>
    </nav>
    <section
        class="h-auto d-flex flex-column justify-content-between align-content-between align-items-stretch"
    >
        <app-about-mobile-menu></app-about-mobile-menu>
        <router-outlet></router-outlet>
        <app-footer-nav [aboutRoutes]="aboutRoutes"></app-footer-nav>
    </section>
</section>
